// ------------------------------------------------------------------------------
// name: homepage
// author: mudas
// created: 2025/7/9
// ------------------------------------------------------------------------------

import { openURL } from './url';
import { ROUTER_PATHNAME } from 'common/router/routes';
import { MANAGER_ROUTER } from 'common/router/manager';

/**
 * 跳转到创作者个人主页
 * - 自动处理前后台差异，跳转到不同的社媒个人主页
 * @param data
 */
export const toHomepage = (data?: { mediaUserId?: number; uniqueId?: number }) => {
  const platform = import.meta.env.VITE_PLATFORM;
  const tgRootURL = import.meta.env.VITE_TIANGONG_URL || window.location.origin;

  if (!!data?.uniqueId) {
    openURL(`${tgRootURL ?? ''}/${ROUTER_PATHNAME.ARTIST_HOME}?userId=${data?.uniqueId}`);
  } else if (!!data?.mediaUserId) {
    if (platform === 'manager') {
      openURL(
        `/tiangong/${MANAGER_ROUTER.RECOMMENDED_TOOLS}/${MANAGER_ROUTER.RECOMMENDED_ARTIST_DETAIL}/${data.mediaUserId}`,
      );
    } else {
      openURL(`${tgRootURL ?? ''}/${ROUTER_PATHNAME.MEDIA_USER_HOME}/${data?.mediaUserId}`);
    }
  }
};
